import React, {useEffect, useState} from "react";
import {css} from "@emotion/react";

import {calculateRemSize, flexAbsoluteCenter, onDesktop, w100} from "@pg-design/helpers-css";

import {CalculatorValueType} from "../../types/CalculatorValueType";
import {CalculatorBaseInput} from "./CalculatorBaseInput";

interface IProps {
    value: number;
    price: number;
    min: number;
    max: number;
    valueType: CalculatorValueType;
    updateValue: (type: CalculatorValueType, value: number) => void;
    updateInputState: (value: number) => void;
    onInvalidValue: (value?: number) => void;
    dataTestId?: string;
}

export const CalculatorPercentageInput = (props: IProps) => {
    const {value, min, max, price, valueType, onInvalidValue, updateValue, updateInputState, dataTestId} = props;

    const [additionalInputValue, setAdditionalInputValue] = useState<number>(price ? (price * value) / 100 : 0);
    const [additionalValueHelper, setAdditionalValueHelper] = useState<number>();

    useEffect(() => {
        if (price && value) {
            setAdditionalInputValue((price * value) / 100);
        }
    }, [value, price]);

    useEffect(() => {
        if (additionalValueHelper) {
            updateValue(valueType, additionalValueHelper);
        }
    }, [additionalValueHelper]);

    const onAdditionalInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseInt(event.target.value.replace(/\s+/g, ""));

        setAdditionalInputValue(newValue);
    };

    const onAdditionalInputBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === "" && min !== value) {
            setAdditionalValueHelper(min);
            return;
        }

        if (event.target.value === "" && value === min) {
            const newValue = (price * value) / 100;
            setAdditionalInputValue(newValue === additionalInputValue ? newValue + 0.1 : newValue);
            return;
        }

        const newValue = parseInt(event.target.value.replace(/\s+/g, ""));
        if (Number.isNaN(newValue)) {
            updateInputState(0);
            return;
        }

        const percent = (newValue * 100) / price;
        if (percent >= max && (price * max) / 100 < newValue) {
            setAdditionalValueHelper(max);
            setAdditionalInputValue(Math.round((price * max) / 100));
            return;
        }

        if (newValue <= additionalInputValue && (price * min) / 100 > newValue) {
            setAdditionalValueHelper(min);
            setAdditionalInputValue(Math.round((price * min) / 100));
            return;
        }

        if (percent && percent > max) {
            setAdditionalValueHelper(max);
            return;
        }
        percent && setAdditionalValueHelper(percent);
    };

    return (
        <div css={inputsWrapperStyle}>
            <CalculatorBaseInput
                value={Math.floor(value)}
                valueType={valueType}
                label="%"
                updateValue={updateValue}
                min={min}
                max={max}
                wrapperStyle={smallInputStyle}
                onInvalidValue={onInvalidValue}
            />
            <CalculatorBaseInput
                value={additionalInputValue}
                valueType={CalculatorValueType.PRICE}
                min={Math.round((price * min) / 100)}
                max={Math.round((price * max) / 100)}
                label="zł"
                wrapperStyle={additionalInputStyle}
                onInvalidValue={onInvalidValue}
                updateValue={updateValue}
                onChange={onAdditionalInputChange}
                onBlur={onAdditionalInputBlur}
                dataTestId={dataTestId}
            />
        </div>
    );
};

const inputsWrapperStyle = css`
    ${flexAbsoluteCenter};
    gap: ${calculateRemSize(0.5)};
    ${w100};

    ${onDesktop(css`
        flex-basis: unset;
        width: unset;
    `)};
`;

const smallInputStyle = css`
    width: 50%;

    ${onDesktop(css`
        width: ${calculateRemSize(10)};
    `)};
`;

const additionalInputStyle = css`
    width: 50%;

    ${onDesktop(css`
        width: ${calculateRemSize(15)};
    `)};
`;
import React, {useEffect, useState} from "react";
import {css} from "@emotion/react";

import {calculateRemSize, flexAbsoluteCenter, onDesktop, w100} from "@pg-design/helpers-css";

import {CalculatorValueType} from "../../types/CalculatorValueType";
import {CalculatorBaseInput} from "./CalculatorBaseInput";

interface IProps {
    value: number;
    price: number;
    min: number;
    max: number;
    valueType: CalculatorValueType;
    updateValue: (type: CalculatorValueType, value: number) => void;
    updateInputState: (value: number) => void;
    onInvalidValue: (value?: number) => void;
    dataTestId?: string;
}

export const CalculatorPercentageInput = (props: IProps) => {
    const {value, min, max, price, valueType, onInvalidValue, updateValue, updateInputState, dataTestId} = props;

    const [additionalInputValue, setAdditionalInputValue] = useState<number>(price ? (price * value) / 100 : 0);
    const [additionalValueHelper, setAdditionalValueHelper] = useState<number>();

    useEffect(() => {
        if (price && value) {
            setAdditionalInputValue((price * value) / 100);
        }
    }, [value, price]);

    useEffect(() => {
        if (additionalValueHelper) {
            updateValue(valueType, additionalValueHelper);
        }
    }, [additionalValueHelper]);

    const onAdditionalInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseInt(event.target.value.replace(/\s+/g, ""));

        setAdditionalInputValue(newValue);
    };

    const onAdditionalInputBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === "" && min !== value) {
            setAdditionalValueHelper(min);
            return;
        }

        if (event.target.value === "" && value === min) {
            const newValue = (price * value) / 100;
            setAdditionalInputValue(newValue === additionalInputValue ? newValue + 0.1 : newValue);
            return;
        }

        const newValue = parseInt(event.target.value.replace(/\s+/g, ""));
        if (Number.isNaN(newValue)) {
            updateInputState(0);
            return;
        }

        const percent = (newValue * 100) / price;
        if (percent >= max && (price * max) / 100 < newValue) {
            setAdditionalValueHelper(max);
            setAdditionalInputValue(Math.round((price * max) / 100));
            return;
        }

        if (newValue <= additionalInputValue && (price * min) / 100 > newValue) {
            setAdditionalValueHelper(min);
            setAdditionalInputValue(Math.round((price * min) / 100));
            return;
        }

        if (percent && percent > max) {
            setAdditionalValueHelper(max);
            return;
        }
        percent && setAdditionalValueHelper(percent);
    };

    return (
        <div css={inputsWrapperStyle}>
            <CalculatorBaseInput
                value={Math.floor(value)}
                valueType={valueType}
                label="%"
                updateValue={updateValue}
                min={min}
                max={max}
                wrapperStyle={smallInputStyle}
                onInvalidValue={onInvalidValue}
            />
            <CalculatorBaseInput
                value={additionalInputValue}
                valueType={CalculatorValueType.PRICE}
                min={Math.round((price * min) / 100)}
                max={Math.round((price * max) / 100)}
                label="zł"
                wrapperStyle={additionalInputStyle}
                onInvalidValue={onInvalidValue}
                updateValue={updateValue}
                onChange={onAdditionalInputChange}
                onBlur={onAdditionalInputBlur}
                dataTestId={dataTestId}
            />
        </div>
    );
};

const inputsWrapperStyle = css`
    ${flexAbsoluteCenter};
    gap: ${calculateRemSize(0.5)};
    ${w100};

    ${onDesktop(css`
        flex-basis: unset;
        width: unset;
    `)};
`;

const smallInputStyle = css`
    width: 50%;

    ${onDesktop(css`
        width: ${calculateRemSize(10)};
    `)};
`;

const additionalInputStyle = css`
    width: 50%;

    ${onDesktop(css`
        width: ${calculateRemSize(15)};
    `)};
`;
